module.exports = __webpack_public_path__ + "static/media/Riven_0.8202af57.jpg";